/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface EtlSetupDTO {
    id?: string;
    name?: string;
    tenant?: string;
    partner?: string;
    personalDataAccessPartners?: Array<string>;
    affectedPartners?: Array<string>;
    owner?: string;
    code?: string;
    complet?: boolean;
    description?: string;
    offset?: number;
    separator?: string;
    loadType?: EtlSetupDTO.LoadTypeEnum;
    contentType?: string;
    destTable?: Array<string>;
    charsetName?: string;
    provider?: string;
    type?: string;
    skipPersonal?: boolean;
    contactType?: EtlSetupDTO.ContactTypeEnum;
    hasHeaderRow?: boolean;
}
export namespace EtlSetupDTO {
    export type LoadTypeEnum = 'SQL' | 'CSV' | 'SCRIPT';
    export const LoadTypeEnum = {
        SQL: 'SQL' as LoadTypeEnum,
        CSV: 'CSV' as LoadTypeEnum,
        SCRIPT: 'SCRIPT' as LoadTypeEnum
    };
    export type ContactTypeEnum = 'CUSTOMER' | 'PROSPECT' | 'SUSPECT';
    export const ContactTypeEnum = {
        CUSTOMER: 'CUSTOMER' as ContactTypeEnum,
        PROSPECT: 'PROSPECT' as ContactTypeEnum,
        SUSPECT: 'SUSPECT' as ContactTypeEnum
    };
}